import { useOrganizationCreateStore } from "@/stores/useOrganizationCreateStore"
import { createFileRoute } from "@tanstack/react-router"
import ScreenWrapper from "@/components/ScreenWrapper"
import { Scoped } from "@/components/forms/organization/StepperDefinition"
import OrganizationFormStepper from "@/components/forms/organization/OrganizationFormStepper"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute("/beheer/organisaties/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "organizations"),
})

function RouteComponent() {
  const { info } = useOrganizationCreateStore()

  return (
    <ScreenWrapper className="mt-8" showManagementMenu>
      <div className="flex w-full">
        <div className="flex flex-col justify-center h-full w-full">
          <h1>Nieuwe organisatie</h1>
          <Scoped initialStep={info ? "contact" : "info"}>
            <OrganizationFormStepper />
          </Scoped>
        </div>
      </div>
    </ScreenWrapper>
  )
}
